import type { AssignmentFormValues, OverTimeRates, PaySplitRates } from "./types";
import type { Equipment } from "@procore/equipment-select";
import type { FormSelectOption } from "@/react/prop-types";
import { commonInitialValuesForRequestAndAssignment } from "../constants";

// creating this constant to limit content on the labor and equipment assignment banners
// this can be changed to any number to limit the content on the banners
export const ASSIGNMENT_CONTENT_LIMIT = 2;

export const formInitialValues = (
   projectId?: string,
   categoryId?: string | null,
   subcategoryId?: string | null,
   people?: Array<FormSelectOption<string>>,
   startDate?: Date,
   endDate?: Date,
   equipment?: Equipment[],
): AssignmentFormValues => {
   return {
      ...commonInitialValuesForRequestAndAssignment,
      ...(startDate !== undefined && { start_date: startDate }),
      ...(endDate !== undefined && { end_date: endDate }),
      resource: people ?? [],
      equipment: equipment ?? null,
      project: projectId
         ? {
              id: projectId,
              label: "", // Label is required for typing but the form field only needs ID
           }
         : null,
      category: categoryId
         ? {
              id: categoryId,
              label: "", // Label is required for typing but the form field only needs ID
           }
         : null,
      subcategory: subcategoryId
         ? {
              id: subcategoryId,
              label: "", // Label is required for typing but the form field only needs ID
           }
         : null,
      overtime: false,
      overtime_rates: DEFAULT_OVERTIME_RATES,
      pay_split: DEFAULT_PAY_SPLIT_RATES,
   };
};

export const DEFAULT_OVERTIME_RATES: OverTimeRates = {
   sunday: 1,
   monday: 1,
   tuesday: 1,
   wednesday: 1,
   thursday: 1,
   friday: 1,
   saturday: 1,
};

export const DEFAULT_PAY_SPLIT_RATES: PaySplitRates = {
   overtime: 0,
   straight: 0,
   unpaid: 0,
};
